// extracted by mini-css-extract-plugin
export default {"reward":"reward_reward__y86pM","title":"reward_title__tbBG4","title2":"reward_title2__XUU7p"};